import React from 'react';
import MomentUtils from '@date-io/moment';
import moment from 'moment';
import ordinal from 'ordinal';
import Header from './Header';

import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';

import logo_13cabs from './13cabs.png';
import logo_13limo from './13limo.png';
import logo_champ from './champ.png';
import logo_silver from './silver.png';

import {
  Button,
  Grid,
  Typography,
  Link,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  Box
} from '@material-ui/core';
import { MuiThemeProvider, createTheme } from '@material-ui/core/styles';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Repeatable, SteppedForm, Step } from '../SteppedForm';

import OperatorFormSummary from './Summary';
import DevToolbox from './DevToolbox';
import StepFaq from './StepFaq';
import getConfigInfo from './config';
import { themeMappings } from './Theme';

import './index.css';
import axios from 'axios';

import StepIntro from './StepIntro';
import StepTermsandconds from './StepTermsandconds';
import StepSales from './StepSales';
import StepOperatorReferral from './StepOperatorReferral';
import StepOperatorReferralDetails from './StepOperatorReferralDetails';
import StepPrevnet from './StepPrevnet';
import StepM7details from './StepM7details';
import StepOperatorlic from './StepOperatorlic';
import StepNetwork from './StepNetwork';
import StepOrgtype from './StepOrgtype';
import StepCompany from './StepCompany';
import StepRelatedorgs from './StepRelatedorgs';
import StepPersonal from './StepPersonal';
import StepPersonalcontact from './StepPersonalcontact';
import StepLicense from './StepLicense';
import StepOwneroperator from './StepOwneroperator';
import StepDriverdetails from './StepDriverDetails';
import StepCabequip from './StepCabequip';
import StepTerminalid from './StepTerminalid';
import StepKin from './StepKin';
import StepPartners from './StepPartners';
import StepOnboardvehicle from './StepOnboardvehicle';
import StepCarprovider from './StepCarprovider';
import StepFinprovider from './StepFinprovider';
import StepPlate from './StepPlate';
import StepPlateprovider from './StepPlateprovider';
import StepPlatelic from './StepPlatelic';
import StepVehicle from './StepVehicle';
import StepTransferofvehicle from './StepTransferofvehicle';
import StepVehiclechange from './StepVehiclechange';
import StepVehicleold from './StepVehicleold';
import StepInsurance from './StepInsurance';
import StepWatsdetails from './StepWatsdetails';
import StepFitout from './StepFitout';
import StepCamera from './StepCamera';
import StepCameraother from './StepCameraother';
import StepVehicles from './StepVehiclesummary';
import StepBank from './StepBank';
import StepVehicleOnboarding from './StepVehicleOnboarding';
import StepCabsure from './StepCabsure';
import StepCabsureDetails from './StepCabsureDetails';
import StepCabsureCoverType from './StepCabsureCoverType';
import StepPaymentTerm from './StepPaymentTerm';
import TagManager from 'react-gtm-module';

console.log('Operator Onboarding V2.1');

const config = await getConfigInfo(process.env.REACT_APP_CONFIG_BLOB_STORAGE_URL);

if (process.env.REACT_APP_DEVELOPMENT === 'false')
{
  const tagManagerArgs = {
    gtmId: config.gtm.TagId
  }
  TagManager.initialize(tagManagerArgs)
}

const themes = {};
config.themes.map((theme) => {
  return (themes[theme.name] = createTheme({
    palette: {
      primary: { main: theme.primary, text: theme.primaryText },
      secondary: {
        main: theme.secondary ? theme.secondary : theme.primary,
        text: theme.secondaryText ? theme.secondaryText : theme.primaryText
      }
    },
    typography: {
      fontFamily: `"Visby CF", Arial`
    }
  }));
});

const carFinOptions = {
  buyfin: {
    label: 'I want to purchase a vehicle and get finance from 13cabs.',
    setData: { onboardcar: true },
    setVehicle: { carbuy: true, carfin: true }
  },
  buy: {
    label: 'I want to purchase a vehicle from 13cabs, I do not need finance from 13cabs.',
    setData: { onboardcar: true },
    setVehicle: { carbuy: true, carfin: false }
  },
  fin: {
    label: 'I want finance from 13cabs, I will buy the vehicle elsewhere.',
    setData: { onboardcar: true },
    setVehicle: { carbuy: false, carfin: true }
  },
  neither: {
    label: 'I will onboard my own vehicle.',
    setData: { onboardcar: true },
    setVehicle: { carbuy: false, carfin: false }
  }
};

const cabsureCoverOptions = {
  mvi: {
    label: 'Motor Vehicle Insurance',
    help: 'Comprehensive or Third-Party Property Damage Motor Vehicle with additional cover options available.'
  },
  ctp: {
    label: 'Compulsory Third Party (CTP)',
    help: 'Opt in/out KM based policies available.'
  },
  both: {
    label: 'Both'
  }
};

const logoMappings = {
  '13cabs': logo_13cabs,
  '13limo': logo_13limo,
  champ: logo_champ,
  silver: logo_silver
};

let styles = {
  linkColor: { color: '#3333FF' },
  note: {
    color: '#AAAAAA',
    fontStyle: 'italic',
    fontSize: '12px'
  }
};
class OperatorForm extends React.Component {
  constructor(props) {
    super(props);
    this.formref = React.createRef();
    
    this.state = {
      step: 0,
      formdata: {
        applicants: [{}],
        vehicles: [{}],
        name_as_correspondance: true,
        op_as_hq: true,
        has_referred_by_operator_or_driver:false
      },
      applicant_index: 0,
      vehicle_index: 0,
      showInfo: false,
      showError: false,
      showReset: false,
      showErase: false,
      operatoraccno: '',
      toStep: '',
      loaded: false
    };

    if (!this.state.startTime) this.state.startTime = Date.now();
  }

  inStates = (states) => states.indexOf(this.state.formdata.state) >= 0;
  inNetworks = (networks) => networks.indexOf(this.state.formdata.network) >= 0;
  limitLength = (value, len) => (isNaN(value) ? value : value + '').substring(0, len);
  toUpperCase = (value) => value.toUpperCase();

  jumpTo(id, bounce, key, value) {
    key && value !== undefined && this.setState({ [key]: value });
    this.formref.current.jumpTo(id, bounce ? this.state.step : undefined);
  }

  getAccountName() {
    let applicant = this.state.formdata.applicants[0];
    return this.state.formdata.orgtype === 'individual'
      ? `${applicant.firstname} ${applicant.surname}`
      : this.state.formdata.orgname;
  }

  getApplicant() {
    return this.state.formdata.applicants[this.state.applicant_index];
  }

  getVehicle() {
    return this.state.formdata.vehicles[this.state.vehicle_index];
  }

  getNetworks() {
    return Object.keys(config.networks).filter((v) => {
      if (!config.states[this.state.formdata.state]) return false;

      if (
        this.state.formdata.region &&
        config.states[this.state.formdata.state].regions[this.state.formdata.region]
      ) {
        return (
          config.states[this.state.formdata.state].regions[this.state.formdata.region].indexOf(v) >=
          0
        );
      } else if (config.states[this.state.formdata.state].regions['']) {
        return config.states[this.state.formdata.state].regions[''].indexOf(v) >= 0;
      } else {
        return false;
      }
    });
  }

  getMakes() {
    try {
      const data = {};
      Object.keys(config.makes).map((make) => (data[make] = [...config.makes[make], 'Other']));
      return { ...data, Other: [] };
    } catch (e) {}
    return config.makes;
  }

  getTaxiServiceLicenceName() {
    if (
      this.state.formdata.state &&
      config.states[this.state.formdata.state].taxiServiceLicenceName
    )
      return config.states[this.state.formdata.state].taxiServiceLicenceName;
    return 'Taxi Service Licence';
  }

  getWheelchairTaxiTerm(index) {
    if (this.state.formdata.state && config.states[this.state.formdata.state].watsterm)
      return config.states[this.state.formdata.state].watsterm[index];
    return index === 0 ? 'WAT' : 'Wheelchair Accessible Taxi';
  }

  getPersonalDetailsTitle(section) {
    if (this.state.formdata.orgtype === 'individual' || this.state.formdata.orgtype === undefined)
      return section ? section : 'Personal Details';

    return (
      ordinal(this.state.applicant_index ? this.state.applicant_index + 1 : 1) +
      ' ' +
      (this.state.formdata.orgtype === 'company'
        ? this.state.applicant_index === 1
          ? 'Director/Secretary '
          : 'Director '
        : 'Partner') +
      (section ? ' - ' + section : '')
    );
  }

  preprocessFormData() {
    // This is for object de referencing, please dont touch it.
    const data = JSON.parse(JSON.stringify(this.state.formdata));

    data.applicants = data.applicants.filter((applicant) => applicant.title);
    for (var applicant of data.applicants) {
      if (applicant.home_as_postal && applicant.postal) delete applicant.postal;
      if (applicant.home_as_kin && applicant.kin_address) delete applicant.kin_address;
      if (applicant.corp_as_home && applicant.home) delete applicant.home;
      applicant.home_as_postal = applicant.home_as_postal ? applicant.home_as_postal : false;
      applicant.home_as_kin = applicant.home_as_kin ? applicant.home_as_kin : false;
      applicant.corp_as_home = applicant.corp_as_home ? applicant.corp_as_home : true;

      if (data.onboardingFor === 'operator') {
        applicant.driverInfo = {
          driveraccred: applicant.owneroperator ? applicant.driveraccred : null,
          driveraccred_date: applicant.owneroperator ? applicant.driveraccred_date : null,
          drivercred: applicant.drivercred ? applicant.drivercred : null,
          drivercredback: applicant.drivercredback ? applicant.drivercredback : null,
          driverpin: applicant.owneroperator ? applicant.driverpin : null,

          driverstateaccred: applicant.driverstateaccred ? applicant.driverstateaccred : null,
          driverstateaccred_date: applicant.driverstateaccred_date
            ? applicant.driverstateaccred_date
            : null,
          driverstatecred: applicant.driverstatecred ? applicant.driverstatecred : null
        };
        delete applicant.driveraccred;
        delete applicant.driveraccred_date;
        delete applicant.drivercred;
        delete applicant.drivercredback;
        delete applicant.driverpin;

        delete applicant.driverstatecred;
        delete applicant.driverstateaccred;
        delete applicant.driveraccred_date;
      }
    }

    if (data.onboardingFor === 'operator' && data.has_referred_by_operator_or_driver) {
      data.operator_referral_details = {
        fullname: data.OperatorReferral_Fullname,
        mobile: data.OperatorReferral_Phone,
        tplate: data.OperatorReferral_TPlate
      }
      delete data.OperatorReferral_Fullname;
      delete data.OperatorReferral_Phone;
      delete data.OperatorReferral_TPlate;
    }

    if (data.network === '13cabs Darwin' || data.network === '13cabs SA') data.network = '13cabs';

    for (var vehicle of data.vehicles) {
      if (config.states[data.state] && config.states[data.state].colour)
        vehicle.colour = config.states[data.state].colour;
      if (config.networks[data.network] && config.networks[data.network].colour)
        vehicle.colour = config.networks[data.network].colour;
      if (!vehicle.carbuy_gst) vehicle.carbuy_gst = false;
      if (!vehicle.carfin_gst) vehicle.carfin_gst = false;
      if (!vehicle.plateOwnership) vehicle.plateOwnership = 'own';
      if (vehicle.shape === 'Wheelchair') vehicle.wats = true;
      if (vehicle.old_shape === 'Wheelchair') vehicle.old_wats = true;

      if (vehicle.requested_cabsure_insurance_quote) {
        vehicle.cabsure_insurance_quote_details = {
          firstname: vehicle.Cabsure_UseDetails
            ? data.applicants[0].firstname
            : vehicle.Cabsure_Firstname,
          surname: vehicle.Cabsure_UseDetails
            ? data.applicants[0].surname
            : vehicle.Cabsure_Surname,
          email: vehicle.Cabsure_UseDetails ? data.applicants[0].email : vehicle.Cabsure_Email,
          mobile: vehicle.Cabsure_UseDetails ? data.applicants[0].mobile : vehicle.Cabsure_Mobile,
          m7_account: vehicle.Cabsure_UseDetails ? data.m7_account : vehicle.Cabsure_M7AccountNo,
          odometer: vehicle.Cabsure_Odometer,
          taxiregistrationnumber: vehicle.Cabsure_Taxi_Registration_Number,
          covertype: vehicle.cabsurecovertype
            ? cabsureCoverOptions[vehicle.cabsurecovertype].label
            : cabsureCoverOptions.mvi.label
        };
      }

      delete vehicle.Cabsure_UseDetails;
      delete vehicle.Cabsure_Firstname;
      delete vehicle.Cabsure_Surname;
      delete vehicle.Cabsure_Email;
      delete vehicle.Cabsure_M7AccountNo;
      delete vehicle.Cabsure_Odometer;
      delete vehicle.Cabsure_Taxi_Registration_Number;
      delete vehicle.cabsurecovertype;
    }

    if (data.relent) {
      data.relent = data.relent.map((relent) => {
        const { id, ...extra } = relent;
        return extra;
      });
    }

    if (data.op_as_hq) data.opaddress = data.hqaddress;
    if (data.name_as_correspondance) data.correspondname = data.orgname;
    if (data.previousnetwork_text) data.previousnetwork = data.previousnetwork_text;
    if (data.orgtype === 'individual') data.gst = data.applicants?.[0]?.gst;
    delete data.op_as_hq;
    delete data.name_as_correspondance;
    delete data.previousnetwork;
    delete data.applicants?.[0]?.gst;

    return data;
  }

  getHomeAddress() {
    if (this.getApplicant().corp_as_home) return this.state.formdata.hqaddress;
    return this.getApplicant().home;
  }

  onPersist = (olddata, newdata) => {
    return new Promise((resolve, reject) => {
      try {
        if (olddata) {
          axios
            .put(process.env.REACT_APP_PERSIST_API + '/' + olddata, JSON.stringify(newdata), {
              headers: {
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PERSIST_API_KEY
              }
            })
            .then((resp) => resolve(olddata));
        } else {
          axios
            .post(process.env.REACT_APP_PERSIST_API, JSON.stringify(newdata), {
              headers: {
                'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PERSIST_API_KEY
              }
            })
            .then((resp) => resolve(resp.data.id));
        }
      } catch (e) {
        reject(e);
      }
    });
  };

  persist = async () => {
    const pdata = {
      data: { ...this.state.formdata },
      step: this.state.step
    };
    await this.onPersist(window.localStorage['operatordata'], pdata);
    this.forceUpdate();
  };

  reset = () => {
    delete window.localStorage.operatordata;
    window.location.reload();
  };

  eraseStepData = () => {
    console.log('eraseStepData');
    let {
      currentnetwork_reason,
      currentnetwork_text,
      currop,
      m7,
      m7_account,
      name_as_correspondance,
      network,
      op_as_hq,
      region,
      state
    } = this.state.formdata;
    this.setState(
      {
        formdata: {
          currentnetwork_reason,
          currentnetwork_text,
          currop,
          m7,
          m7_account,
          name_as_correspondance,
          network,
          op_as_hq,
          region,
          state,
          orgtype: 'individual',
          applicants: [{}],
          vehicles: [{}]
        }
      },
      () => this.jumpTo('personal')
    );
    this.closeErase();
  };

  refresh = () => {
    window.location.reload();
  };

  getStepDetails = (stepNum) =>
    this.formref.current.state.stepDetails[this.formref.current.state.steps[stepNum]];

  onRestore = async (data) => {
    try {
      const request = await axios.get(process.env.REACT_APP_PERSIST_API + '/' + data, {
        headers: {
          'Ocp-Apim-Subscription-Key': process.env.REACT_APP_PERSIST_API_KEY
        }
      });

      if (request.data.error) throw request.data.error;
      if (process.env.REACT_APP_DEVELOPMENT === 'true') {
        console.log('onRestore', request.data);
      }
      setTimeout(() => {
        if (!this.formref.current) return;
        this.setState({
          toStep: this.formref.current.state.steps[request.data.step]
        });
      });
      return request.data;
    } catch (err) {
      if (err.statusCode === 404) {
        this.reset();
        return;
      }
      this.setState({ showError: true });
      console.log('Error:', err.name, err.message);
      // throw err
    }
  };

  onDataChange = (data, cb) => {
    cb = typeof cb === 'function' ? cb : function () {};
    this.setState({ formdata: { ...this.state.formdata, ...data } }, () => {
      if (this.state.formdata.state && this.getNetworks().length === 1) {
        this.setState(
          {
            formdata: {
              ...this.state.formdata,
              network: this.getNetworks()[0]
            }
          },
          () => {
            console.log(this.state.formdata);
            cb();
          }
        );
      } else {
        console.log(this.state.formdata);
        cb();
      }
    });
  };

  closeError = () => this.setState({ showError: false });
  openError = () => this.setState({ showError: true });
  errorContent = () => (
    <Dialog open={this.state.showError} onClose={this.closeError} maxWidth="lg">
      <DialogContent>
        <div>Something went wrong, reset to clear all data and restart the application</div>
        {process.env.REACT_APP_PERSIST_API?.toLowerCase().indexOf('encode') >= 0 ? (
          <div style={{ color: 'red', float: 'right' }}>(You are in secure mode)</div>
        ) : (
          ''
        )}
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={this.reset}>
          Reset
        </Button>
        <Button variant="contained" color="primary" onClick={this.refresh} autoFocus>
          Retry
        </Button>
      </DialogActions>
    </Dialog>
  );

  openReset = () => this.setState({ showReset: true });
  closeReset = () => this.setState({ showReset: false });

  openErase = () => this.setState({ showErase: true });
  closeErase = () => this.setState({ showErase: false });
  askErase = (id, value) => {
    console.log(id, value);
    this.setState({ showErase: true });
  };

  promptContent = (title, content, flag, closeAction, okText = 'OK', okAction) => (
    <Dialog open={this.state[flag]} onClose={closeAction} maxWidth="md">
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {content}
        <br />
        <br />
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={closeAction}>
          Cancel
        </Button>
        <Button variant="contained" color="primary" onClick={okAction} autoFocus>
          {okText}
        </Button>
      </DialogActions>
    </Dialog>
  );

  infoContent = () => (
    <Dialog open={this.state.showInfo} onClose={this.closeInfo} maxWidth="md">
      <DialogContent>
        <Typography variant="h6" style={styles.linkColor}>
          To complete this application, you will need to know:
        </Typography>
        <ul>
          <li>
            <Typography>all company and partner or director details</Typography>
          </li>
          <li>
            <Typography>the region you will operate your Taxi</Typography>
          </li>
          <li>
            <Typography>the network you want to join (13cabs, Silver Service or CHAMP)</Typography>
          </li>
          <li>
            <Typography>the address from which you will be operating the Taxi</Typography>
          </li>
          <li>
            <Typography>if you need to rent a Taxi from 13cabs</Typography>
          </li>
          <li>
            <Typography>if you want to buy a Taxi from 13cabs</Typography>
          </li>
          <li>
            <Typography>details of your Taxi Plate</Typography>
          </li>
          <li>
            <Typography>if you want to apply for vehicle finance through 13cabs</Typography>
          </li>
          <li>
            <Typography>
              contact details for your finance provider, if you are not applying for finance through
              13cabs
            </Typography>
          </li>
          <li>
            <Typography>if you are applying as an Individual, Partnership or Company</Typography>
          </li>
          <li>
            <Typography>
              your 13cabs account number, if you already have an account with 13cabs
            </Typography>
          </li>
          <li>
            <Typography>the details of your Taxi, if you are not buying it from 13cabs</Typography>
          </li>
          <li>
            <Typography>your bank account details</Typography>
          </li>
          <li>
            <Typography>
              bank account details for any other people applying for a Spotto terminal
            </Typography>
          </li>
          <li>
            <Typography>
              details of your camera system if you are not renting one from 13cabs
            </Typography>
          </li>
          <li>
            <Typography>your Cabcharge terminal ID if you are providing your own</Typography>
          </li>
        </ul>
        <div>
          <Typography variant="h6" style={styles.linkColor}>
            You will also need these documents:
          </Typography>
          <ul>
            <li>
              <Typography>Driver Licence (image of front and back)</Typography>
            </li>
            <li>
              <Typography>
                an additional form of identification (eg, Birth Certificate, Passport, Certificate
                of Australian Citizenship, Australian Visa, Marriage Certificate or Medicare card)
              </Typography>
            </li>
            <li>
              <Typography>your Taxi plate certificate</Typography>
            </li>
            <li>
              <Typography>
                your {this.getWheelchairTaxiTerm(0)} engineering certificate if adding a{' '}
                {this.getWheelchairTaxiTerm(0)}
              </Typography>
            </li>
          </ul>
        </div>
      </DialogContent>
      <DialogActions>
        <Link
          id="downloadIntro"
          style={{ display: 'none' }}
          target="_blank"
          href="preRequirement.pdf">
          Download
        </Link>
        <Button variant="contained" color="primary" onClick={this.downloadIntro}>
          Download
        </Button>
        <Button variant="contained" color="primary" onClick={this.printInfo}>
          Print
        </Button>
        <Button variant="contained" color="primary" onClick={this.closeInfo} autoFocus>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );

  openInfo = () => this.setState({ showInfo: true });
  closeInfo = () => this.setState({ showInfo: false });
  printInfo = () => {
    window.print();
    this.closeInfo();
  };

  clearRegionAndNetwork = () => {
    if (process.env.REACT_APP_LOCALHOST) return;
    console.log(
      'clearRegionAndNetwork',
      this.state.formdata.state,
      this.state.formdata.currentState
    );
    if (this.state.formdata.state !== this.state.formdata.currentState) {
      this.setState({
        formdata: {
          ...this.state.formdata,
          network: '',
          region: '',
          currentState: this.state.formdata.state
        }
      });
    }
  };

  downloadIntro = () => document.getElementById('downloadIntro').click();

  render() {
    const stateconfig = () =>
      config.states[this.state.formdata.state] ? config.states[this.state.formdata.state] : {};

    const networkconfig = () =>
      config.networks[this.state.formdata.network]
        ? config.networks[this.state.formdata.network]
        : {};

    const getMaxAge = () => {
      if (this.getVehicle().shape === 'Wheelchair') {
        return stateconfig().maxwatsage
          ? moment().add(-stateconfig().maxwatsage, 'years')
          : undefined;
      } else
        return networkconfig().maxage ? moment().add(-networkconfig().maxage, 'years') : undefined;
    };

    return (
      <>
        <MuiThemeProvider
          theme={
            themeMappings[
              this.state.formdata.network && this.state.formdata.network.length > 0
                ? config.networks[this.state.formdata.network].theme
                : 'default'
            ]
          }>
          {this.promptContent(
            'Reset',
            'Reset will erase all the data. Do you really want to do that?',
            'showReset',
            this.closeReset,
            'Reset',
            this.reset
          )}

          {this.promptContent(
            'Erase data after this step',
            'click ERASE will erase all the data after this step. Do you really want to do that?',
            'showErase',
            this.closeErase,
            'Erase',
            this.eraseStepData
          )}

          {this.errorContent()}

          <Header />
          <Box pt={5} pb={5}>
            {this.state.loaded && (
              <Grid container justify="center" spacing={3}>
                {this.state.formdata.network && networkconfig().image ? (
                  <Grid item>
                    <img
                      style={{ height: '100px' }}
                      src={logoMappings[networkconfig().theme]}
                      alt={networkconfig().logo + ' Logo'}
                    />
                  </Grid>
                ) : (
                  Object.values(config.networks)
                    .filter((o, i, self) => i === self.map((o2) => o2.image).indexOf(o.image))
                    .map((network, i) => (
                      <Grid item>
                        <img
                          key={i}
                          style={{ height: '100px' }}
                          src={logoMappings[network.theme]}
                          alt={networkconfig().logo + ' Logo'}
                        />
                      </Grid>
                    ))
                )}
              </Grid>
            )}
          </Box>

          <SteppedForm
            formkey="operatordata"
            formdata={this.state.formdata}
            ref={this.formref}
            step={this.state.step}
            preserveAfterSubmit
            className={
              (this.state.formdata.network ? 'network-' + networkconfig().theme : '') +
              ' ' +
              (process.env.REACT_APP_DEVELOPMENT ? 'development' : '')
            }
            loadContent={(date) => (
              <Backdrop open={true} className="loading">
                <div>
                  <CircularProgress color="inherit" />
                  <h1>Welcome back</h1>
                  <Typography variant="body1">
                    Loading application last modified on the{' '}
                    {moment(date).format('Do of MMMM, YYYY')}
                    ...
                  </Typography>
                </div>
              </Backdrop>
            )}
            onLoad={() => {
              this.setState({ loaded: true });              
            }}
            onBeforeNext={(step, currentStep, callback) => {
              console.log(
                'onBeforeNext',
                step,
                currentStep,
                this.formref.current.state.steps[step],
                this.formref.current.state.steps[currentStep]
              );

              if (this.formref.current.state.steps[currentStep] === 'onboardvehicle') {
                let vehicle = this.state.formdata.vehicles[this.state.vehicle_index];
                let setVehicle = carFinOptions[vehicle.carbuyfin].setVehicle || {};
                let setData = carFinOptions[vehicle.carbuyfin].setData || {};
                this.setState(
                  {
                    formdata: {
                      ...this.state.formdata,
                      ...setData,
                      vehicles: this.state.formdata.vehicles.map((v, i) =>
                        i === this.state.vehicle_index ? { ...v, ...setVehicle } : v
                      )
                    }
                  },
                  callback
                );
              } else if (this.formref.current.state.steps[step] === 'summary') {
                this.setState(
                  {
                    formdata: {
                      ...this.state.formdata,
                      visitedSummary: true
                    }
                  },
                  callback
                );
              } else if (
                this.formref.current.state.steps[currentStep] === 'partners' &&
                this.state.formdata.visitedSummary
              ) {
                this.jumpTo('summary');
              } else {
                callback();
              }
            }}
            onBeforeBack={(step, currentStep, callback) => {
              callback();
            }}
            onStepChange={(step, currentStep) => {
              console.log('onStepChange', step, currentStep);
              //this.outputStepSkip(step);
              this.setState({ toStep: this.formref.current.state.steps[step] });
              if (
                this.formref.current.state.steps[step] === 'partners' &&
                this.state.formdata.orgtype === 'partnership' &&
                this.state.formdata.applicants.length <= 1
              ) {
                this.setState({
                  step: this.formref.current.state.steps.indexOf('personal'),
                  applicant_index: this.state.formdata.applicants.length,
                  formdata: {
                    ...this.state.formdata,
                    applicants: [...this.state.formdata.applicants, {}]
                  }
                });
              } else if (this.formref.current.state.steps[currentStep] === 'intro') {
                this.setState({ step: step }, this.clearRegionAndNetwork());
              } else {
                this.setState({ step: step });
              }

              if (this.state.formdata.onboardingFor === 'vehicle' && !this.state.formdata.currop)
                this.setState({
                  formdata: {
                    ...this.state.formdata,
                    currop: true
                  }
                });

              // Sets the region and network in the event they aren't set by themselves
              if (
                this.formref.current.state.steps.indexOf('network') !== -1 &&
                step > this.formref.current.state.steps.indexOf('network') &&
                !('region' in this.state.formdata && this.state.formdata.region !== '') &&
                !('network' in this.state.formdata && this.state.formdata.network !== '')
              ) {
                this.setState(
                  {
                    formdata: {
                      ...this.state.formdata,
                      region: Object.keys(stateconfig().regions)[0]
                    }
                  },
                  () => {
                    this.setState({
                      formdata: {
                        ...this.state.formdata,
                        network: this.getNetworks()[0]
                      }
                    });
                  }
                );
              }
            }}
            onDataChange={this.onDataChange}
            onSubmit={async () => {
              // console.log('onSubmit', JSON.stringify(this.preprocessFormData()))
              let result = await axios.post(
                process.env.REACT_APP_SUBMIT_API,
                JSON.stringify(this.preprocessFormData()),
                {
                  headers: {
                    'Ocp-Apim-Subscription-Key': process.env.REACT_APP_SUBMIT_API_KEY
                  }
                }
              );
              setTimeout(() => this.reset(), 5000);
              return result.data;
            }}
            onPersist={this.onPersist}
            onRestore={this.onRestore}
            onReset={this.openReset}>
            <MuiPickersUtilsProvider utils={MomentUtils}>
              <StepIntro config={config} openInfo={this.openInfo} infoContent={this.infoContent} />

              <StepFaq
                stateconfig={stateconfig}
                state={this.state.formdata.state}
                jumpTo={(arg) => this.jumpTo(arg)}
              />

              <StepTermsandconds key="StepTermsandconds" state={this.state} />

              <StepSales key="StepSales" config={config} />

              {/* <StepCurrop key="StepCurrop" /> */}
              <StepVehicleOnboarding
                state={this.state}
                setState={(state) => this.setState(state)}
              />

              <StepOperatorReferral state={this.state}/>

              <StepOperatorReferralDetails state={this.state}/>

              <StepPrevnet
                config={config}
                state={this.state}
                stateconfig={stateconfig}
                key={this.state.formdata.currop}
              />

              {/* <StepM7 /> */}
              <StepM7details limitLength={this.limitLength} state={this.state} />

              <StepOperatorlic
                stateconfig={stateconfig}
                getTaxiServiceLicenceName={(arg) => this.getTaxiServiceLicenceName(arg)}
                inStates={(arg) => this.inStates(arg)}
                limitLength={(arg, arg1) => this.limitLength(arg, arg1)}
              />

              <StepNetwork
                state={this.state}
                networkconfig={networkconfig}
                stateconfig={stateconfig}
                getNetworks={(arg) => this.getNetworks(arg)}
                inStates={(arg) => this.inStates(arg)}
              />

              <StepOrgtype state={this.state} askErase={(arg, arg1) => this.askErase(arg, arg1)} />

              <StepCompany
                key={this.state.formdata.orgtype}
                state={this.state}
                limitLength={(arg, arg1) => this.limitLength(arg, arg1)}
                stateconfig={stateconfig}
              />

              <StepRelatedorgs
                state={this.state}
                stateconfig={stateconfig}
                persist={(arg) => this.persist(arg)}
                limitLength={(arg) => this.limitLength(arg)}
                setState={(arg, arg1) => this.setState(arg, arg1)}
                key={this.state.formdata.orgtype + this.state.formdata.relent}
              />

              <Repeatable
                type="applicant"
                index={this.state.applicant_index}
                datakey="applicants"
                onDelete={(index) => {
                  this.setState({
                    applicant_index: 0,
                    formdata: {
                      ...this.state.formdata,
                      applicants: this.state.formdata.applicants.filter((app, i) =>
                        i === index ? false : true
                      )
                    }
                  });
                }}>
                <StepPersonal
                  config={config}
                  state={this.state}
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  limitLength={(arg, arg1) => this.limitLength(arg, arg1)}
                />

                <StepPersonalcontact
                  state={this.state}
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                  getHomeAddress={(arg) => this.getHomeAddress(arg)}
                />

                <StepLicense
                  config={config}
                  state={this.state}
                  stateconfig={stateconfig}
                  documents={config.documents}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                  toUpperCase={(arg) => this.toUpperCase(arg)}
                />

                <StepOwneroperator
                  state={this.state}
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                  stateconfig={stateconfig}
                />

                <StepDriverdetails
                  state={this.state}
                  inStates={(arg) => this.inStates(arg)}
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                  stateconfig={stateconfig}
                />

                <StepCabequip
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                />

                <StepTerminalid
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                />

                <StepKin
                  config={config}
                  state={this.state}
                  getHomeAddress={(arg) => this.getHomeAddress(arg)}
                  getPersonalDetailsTitle={(arg) => this.getPersonalDetailsTitle(arg)}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  getApplicant={(arg) => this.getApplicant(arg)}
                  stateconfig={stateconfig}
                />

                <StepPartners
                  state={this.state}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  jumpTo={(arg) => this.jumpTo(arg)}
                />
              </Repeatable>

              <Repeatable
                type="vehicle"
                index={this.state.vehicle_index}
                datakey="vehicles"
                onDelete={(index) => {
                  this.setState({
                    vehicle_index: 0,
                    formdata: {
                      ...this.state.formdata,
                      vehicles: this.state.formdata.vehicles.filter((v, i) =>
                        index === i ? false : true
                      )
                    }
                  });
                }}>
                <StepOnboardvehicle
                  state={this.state}
                  inNetworks={(arg) => this.inNetworks(arg)}
                  inStates={(arg) => this.inStates(arg)}
                  carFinOptions={carFinOptions}
                />

                <StepCarprovider
                  state={this.state}
                  stateconfig={stateconfig}
                  networkconfig={networkconfig}
                  getVehicle={() => this.getVehicle()}
                />

                <StepFinprovider
                  key={'FinProvider ' + this.state.formdata.state}
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                />

                <StepPlate
                  state={this.state}
                  inStates={(arg) => this.inStates(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                />

                <StepPlateprovider
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                  toUpperCase={this.toUpperCase}
                  limitLength={this.limitLength}
                />

                <StepPlatelic
                  state={this.state}
                  inStates={(arg) => this.inStates(arg)}
                  toUpperCase={(arg) => this.toUpperCase(arg)}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                />

                <StepVehicle
                  config={config}
                  state={this.state}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                  getMaxAge={getMaxAge}
                  getWheelchairTaxiTerm={(arg) => this.getWheelchairTaxiTerm(arg)}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  toUpperCase={(arg) => this.toUpperCase(arg)}
                  getMakes={(arg) => this.getMakes(arg)}
                />

                <StepTransferofvehicle
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                />

                <StepVehiclechange
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  stateconfig={stateconfig}
                />

                <StepVehicleold
                  config={config}
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                  toUpperCase={(arg) => this.toUpperCase(arg)}
                  getMakes={(arg) => this.getMakes(arg)}
                />

                <StepInsurance
                  state={this.state}
                  stateconfig={stateconfig}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  toUpperCase={(arg) => this.toUpperCase(arg)}
                />

                <StepCabsure state={this.state} getVehicle={(arg) => this.getVehicle(arg)} />

                <StepCabsureCoverType
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  inStates={(arg) => this.inStates(arg)}
                  cabsureCoverOptions={cabsureCoverOptions}
                />

                <StepCabsureDetails state={this.state} getVehicle={(arg) => this.getVehicle(arg)} />

                <StepWatsdetails state={this.state} getVehicle={(arg) => this.getVehicle(arg)} />

                <StepFitout
                  state={this.state}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  stateconfig={stateconfig}
                />

                <StepCamera state={this.state} getVehicle={(arg) => this.getVehicle(arg)} />

                <StepCameraother
                  state={this.state}
                  jumpTo={(arg) => this.jumpTo(arg)}
                  getVehicle={(arg) => this.getVehicle(arg)}
                  networkconfig={networkconfig}
                  stateconfig={stateconfig}
                />

                <StepVehicles
                  state={this.state}
                  stateconfig={stateconfig}
                  jumpTo={(arg) => this.jumpTo(arg)}
                  setState={(arg, arg1) => this.setState(arg, arg1)}
                />
              </Repeatable>

              <StepPaymentTerm config={config} stateconfig={stateconfig}/>

              <StepBank
                getAccountName={(arg) => this.getAccountName(arg)}
                limitLength={(arg, arg1) => this.limitLength(arg, arg1)}
              />

              <Step id="summary" title="Application Summary" className="summary" nextText="Submit">
                <OperatorFormSummary
                  inNetworks={this.inNetworks}
                  inStates={this.inStates}
                  stateconfig={stateconfig}
                  networkconfig={networkconfig}
                  documents={config.documents}
                  formdata={this.state.formdata}
                  jumpTo={(step, back, key, value) => this.jumpTo(step, back, key, value)}
                />
              </Step>
              <Step id="done" title="Application Complete" nonext>
                <h3>Congratulations!</h3>
                <Typography variant="body1">
                  Thank you for choosing to be a part of the {this.state.formdata.network} fleet as
                  a Professional Operator! Our Partner Support Team has your details and will be in
                  touch.
                </Typography>
              </Step>
            </MuiPickersUtilsProvider>
          </SteppedForm>

          {process.env.REACT_APP_DEVELOPMENT === 'true' ? (
            <DevToolbox
              state={{ ...this.state, stepIds: this.formref.current?.state.steps || [] }}
              setState={(state) => this.setState(state)}
              jumpTo={(to) => this.jumpTo(to)}
              reset={() => this.reset()}
              preprocessformdata={() => this.preprocessFormData()}
            />
          ) : (
            ''
          )}
        </MuiThemeProvider>
      </>
    );
  }
}

export default OperatorForm;
